import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 20px;

  .invest.button,
  .withdraw.button {
    margin: 0;
    width: fit-content;
    padding: 0 32px;
  }

  .withdraw.button {
    margin-left: 20px;
  }

  .button.box {
    display: flex;

    @media (max-width: 350px) {
      flex-direction: column;

      button {
        margin-top: 12px;
        width: 100%;
      }

      button.withdraw.button {
        margin-left: 0;
      }
    }
  }

  .alignRow {
    height: 112px;

    .alignItems {
      display: flex;
    }

    @media (max-width: 940px) {
      height: 100%;
      width: 100%;
      flex-direction: column;

      .alignItems {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      .alignItems > div {
        margin: 12px 0;
      }

      .alignItems > :last-child {
        text-align: right;
      }
    }
  }

  @media (max-width: 940px) {
    .cashbackItems {
      padding: 0;
    }
  }

  .alignBanner {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    & > div {
      padding: 0;
      margin: 0;
    }

    img {
      width: 500px;

      @media (max-width: 540px) {
        width: 100%;
      }
    }
  }
`;

export const AlignTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
  }

  .alignHelp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    @media (max-width: 720px) {
      margin-top: 20px;
    }

    a {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: ${props => props.theme.colors.primary.main};
    }

    .question {
      height: 20px;
      width: 20px;
      color: white;

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 50%;
      background: ${props => props.theme.colors.primary.main};
      margin: 0 10px;
    }
  }
`;

export const AlignButton = styled.div`
  margin: 12px auto 0 auto;
  width: 200px;
`;
